import { parseToRgba, rgba } from 'color2k';

export function setAlpha(color: string, alpha: number): string {
  const [r, g, b] = parseToRgba(color);
  return rgba(r, g, b, alpha);
}
